import { render, staticRenderFns } from "./CardSidebarTabComments.vue?vue&type=template&id=cd53af20&scoped=true"
import script from "./CardSidebarTabComments.vue?vue&type=script&lang=js"
export * from "./CardSidebarTabComments.vue?vue&type=script&lang=js"
import style0 from "./CardSidebarTabComments.vue?vue&type=style&index=0&id=cd53af20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd53af20",
  null
  
)

export default component.exports